import { addDays, format, parse } from 'date-fns'
import isEqual from 'lodash/isEqual'

const getThreeDaysFromDepartureDate = (slice) => {
  const departDate = parse(slice.date, 'yyyyMMdd', new Date())
  return format(addDays(departDate, 3), 'yyyyMMdd')
}

const getUpdatedSlices = (tripSlices, tripType) => {
  const slices = [{ ...tripSlices[0] }]
  if (tripType === 'RT') {
    slices[0].returnDate = getThreeDaysFromDepartureDate(slices[0])
  }
  if (tripType === 'MD') {
    const lastIndex = tripSlices.length - 1
    slices.push({
      origAirportCode: slices[lastIndex].destAirportCode,
      destAirportCode: null,
      date: getThreeDaysFromDepartureDate(slices[lastIndex]),
    })
  }
  return slices
}

const getSearchType = (airportCode, airports) => (airports[airportCode].cityCode === airportCode ? 1 : 0)

const getFormattedSlices = (slices, airports) =>
  slices.map((slice) => ({
    ...slice,
    origSearchType: getSearchType(slice.origAirportCode, airports),
    destSearchType: getSearchType(slice.destAirportCode, airports),
  }))

const getSearchParams = ({
  tripType,
  tripSlices,
  cabinClass,
  queryParams,
  passengers,
  useFlexDates,
  airports,
}) => {
  const slices = [...tripSlices]
  if (tripType === 'RT') {
    slices.push({
      origAirportCode: slices[0].destAirportCode,
      destAirportCode: slices[0].origAirportCode,
      date: slices[0].returnDate,
    })
  }
  return {
    slices: getFormattedSlices(slices, airports),
    cabinClass,
    queryParams,
    travelers: passengers,
    flexDates: useFlexDates,
  }
}

const getSwappedSlices = (tripSlices) => [
  {
    ...tripSlices[0],
    origAirportCode: tripSlices[0]?.destAirportCode,
    destAirportCode: tripSlices[0].origAirportCode,
  },
]

const getAddSlice = (tripSlices) => {
  const lastIndex = tripSlices.length - 1
  return [
    ...tripSlices,
    {
      origAirportCode: tripSlices[lastIndex]?.destAirportCode,
      destAirportCode: null,
      date: getThreeDaysFromDepartureDate(tripSlices[lastIndex]),
    },
  ]
}

const getRemoveSlice = (tripSlices, index) => {
  const slices = []
  tripSlices.forEach((slice, i) => {
    if (i !== index) {
      slices.push({ ...slice })
    }
  })
  return slices
}

const getUpdateSlice = (tripSlices, index, key, val) => {
  const slices = [...tripSlices]
  slices[index][key] = val
  return slices
}

const getChanged = ({
  cabinClass,
  defaultCabinClass,
  tripType,
  defaultTripType,
  passengers,
  defaultPassengers,
  tripSlices,
  defaultTripSlices,
}) => {
  const changed = []
  if (cabinClass !== defaultCabinClass) {
    changed.push('CabinClass')
  }

  if (tripType !== defaultTripType) {
    changed.push('TripType')
  }

  if (!isEqual(passengers, defaultPassengers)) {
    changed.push('Passenger')
  }

  if (!isEqual(tripSlices, defaultTripSlices)) {
    const { date, destAirportCode, origAirportCode, returnDate } = tripSlices[0]
    const {
      date: date1,
      destAirportCode: destAirportCode1,
      origAirportCode: origAirportCode1,
      returnDate: returnDate1,
    } = defaultTripSlices[0]

    if (origAirportCode !== origAirportCode1) {
      changed.push('Origin')
    }

    if (destAirportCode !== destAirportCode1) {
      changed.push('Destination')
    }

    if (date !== date1 || returnDate !== returnDate1) {
      changed.push('Date')
    }
  }

  return changed
}

export {
  getThreeDaysFromDepartureDate,
  getUpdatedSlices,
  getSearchParams,
  getSwappedSlices,
  getAddSlice,
  getRemoveSlice,
  getUpdateSlice,
  getChanged,
}
